// common fields
const abstractRecord = {
  firstName: '',
  lastName: '',
  sex: '',
  birthDate: '',
  firstUSEnrollmentDate: '',
  bornInUS: '',
  gradeEntering: '',
  enrollingAt: '',
  enrollingAtDate: '',
  permNumber: '',
  comment: '',
  languageContexts: [],
}
// base student model
export const emptyStudent = {
  ...abstractRecord,
  homeLanguageCode: '',
}
// base survey model
export const emptySurvey = {
  ...abstractRecord,
  responseId: '',
  screenerName: '', //"contact"
  screenedDate: '',
  entryDate: '', //date survey entered
  specificLanguage: { id: null, name: null },
  wasScreened: '',
  isImmigrant: '',
}
// default shape for an options list
export const emptyOptions = [{label: null, value: null}];
// grades const for options
export const grades = [
  { value: 'PK', label: 'Pre-K' },
  { value: 'K', label: 'Kindergarten' },
  { value: '01', label: 'Grade 1' },
  { value: '02', label: 'Grade 2' },
  { value: '03', label: 'Grade 3' },
  { value: '04', label: 'Grade 4' },
  { value: '05', label: 'Grade 5' },
  { value: '06', label: 'Grade 6' },
  { value: '07', label: 'Grade 7' },
  { value: '08', label: 'Grade 8' },
  { value: '09', label: 'Grade 9' },
  { value: '10', label: 'Grade 10' },
  { value: '11', label: 'Grade 11' },
  { value: '12', label: 'Grade 12' },
]
